import * as React from "react";
import classNames from "classnames";

interface Props {
    title: string;
    open?: boolean
}
interface State {
    open: boolean;
}

export default class QuestionAnswerToggler extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);
        this.state ={
            open: this.props.open || false
        };
    }
    componentDidMount(){
    }

    render() {
        let toggled = this.state.open;

        let togglerClass = classNames(
        {
            "df-toggler-question": true,
            "toggled": toggled
        });
        let iconClass = classNames({
            "fa" : true,
            "fa-chevron-down": true,
            "rotate-180": toggled
        });
        return (
            <div className={"df-qa-toggler"}>
            <button onClick={() => this.toggle()}
                    className={togglerClass}
                    aria-pressed={toggled}>
                <span>{this.props.title}</span>
                <i className={iconClass} />
            </button>
                {toggled && (
                    <div className="df-toggler-answer">
                        <i className={"fa fa-level-up-alt rotate-90"} />
                        <div>
                            {this.props.children}
                        </div>
                </div>)}
            </div>
        )
    }
    toggle(){
        this.setState({
            open: !this.state.open
        })
    }

}